// frontend/src/marketing/navConfig.js
//
// Shared navigation model for the public site — consumed by the header
// mega-menus and the footer columns so links never drift apart.

export const SOLUTIONS = [
  { label: "Retail", to: "/solutions/retail", desc: "Packaging, scan-to-pay, reviews" },
  { label: "Restaurants", to: "/solutions/restaurants", desc: "Menus, table tents, feedback" },
  { label: "Real estate", to: "/solutions/real-estate", desc: "Signs, tours, brochures" },
  { label: "Events", to: "/solutions/events", desc: "Tickets, check-in, schedules" },
  { label: "Packaging", to: "/solutions/packaging", desc: "Ingredients, recipes, authenticity" },
  { label: "Education", to: "/solutions/education", desc: "Handouts, library, wayfinding" },
];

export const RESOURCES = [
  { label: "Documentation", to: "/docs", desc: "Guides and how-tos" },
  { label: "API reference", to: "/docs/api", desc: "REST endpoints & keys" },
  { label: "FAQ", to: "/docs/faq", desc: "Common questions" },
  { label: "QR code types", to: "/qr-types", desc: "URL, vCard, WiFi, menu…" },
];

export const PRIMARY_NAV = [
  { label: "Features", to: "/features" },
  { label: "Solutions", children: SOLUTIONS },
  { label: "Pricing", to: "/pricing" },
  { label: "Docs", children: RESOURCES },
];

export const FOOTER_COLUMNS = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/features" },
      { label: "Pricing", to: "/pricing" },
      { label: "QR code types", to: "/qr-types" },
      { label: "Security", to: "/security" },
    ],
  },
  {
    title: "Solutions",
    links: SOLUTIONS.map(({ label, to }) => ({ label, to })),
  },
  {
    title: "Resources",
    links: [
      { label: "Documentation", to: "/docs" },
      { label: "Getting started", to: "/docs/getting-started" },
      { label: "API reference", to: "/docs/api" },
      { label: "Troubleshooting", to: "/docs/troubleshooting" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "Log in", to: "/login" },
      { label: "Get started free", to: "/register" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms", to: "/legal/terms" },
      { label: "Privacy", to: "/legal/privacy" },
      { label: "Cookies", to: "/legal/cookies" },
      { label: "Acceptable use", to: "/legal/acceptable-use" },
      { label: "DPA", to: "/legal/dpa" },
    ],
  },
];
